<template>
    <div class="accountSection containerDiv mt-3 mb-0">
        <h1 v-b-toggle.account-list class="accounts-label">
            <a>Accounts</a>
            <font-awesome-icon :icon="accountexpandStateIcon" class="float-right margin-point-4rem" />
        </h1>
        <b-collapse id="account-list" visible>
            <b-card class="mt-2">
                <b-table ref="selectableAccountsTable"
                         no-border-collapse
                         striped
                         head-variant="head-border"
                         selected-variant
                         :sticky-header="height"
                         :show-empty="showempty"
                         :busy.sync="isBusy"
                         :items="accounts"
                         :fields="columnsfield"
                         selectable
                         select-mode="single"
                         @row-selected="setAccount">
                    <template v-slot:table-busy>
                        <div class="text-center">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template v-slot:head(remove)="data">
                        Remove From Account |
                        <span>
                            <a :class="accounts.length == 0 ? 'link-disabled' :'header-link'"
                               @click="accounts.length == 0 ? '' : RemoveAllNotification()">Remove All</a>
                        </span>
                    </template>
                    <template v-slot:cell(remove)="data">
                        <a v-on:click="remove(data)" class="link" :title="data.value">Remove</a>
                    </template>
                </b-table>
            </b-card>
        </b-collapse>
        <div>
            <b-modal id="RemovePromptModal"
                     ref="RemovePromptModal"
                     title="BootstrapVue"
                     class="modal-backdrop"
                     no-close-on-esc
                     no-close-on-backdrop
                     :no-enforce-focus="true">
                <template slot="modal-header">
                    <h5 class="modal-title">Confirmation</h5>
                </template>
                <template slot="default">
                    <p>{{ removemessage }}</p>
                </template>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button class="um-btn" @click="cancel()">Cancel</b-button>
                    <b-button class="um-btn" @click="ConfirmYesClick">Remove</b-button>
                </template>
            </b-modal>
        </div>
        <InfoPopup :popupmessage="info.message" :title="info.title" src="accounts" ref="InfoModel"></InfoPopup>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
        <ToggleUserStatus :userDetail="userDetail"
                          :message="message"
                          :headerMessage="headerMessage"
                          :StatusButtonTxt="StatusButtonTxt"
                          :isValid="isValid"
                          @statusChanged="onStatusChanged" ref="UserStatusModal"></ToggleUserStatus>
    </div>
</template>

<script>
    import service from "../../services/api.services";
    import { eventbus } from "../../main";
    import Loading from "vue-loading-overlay";
    import InfoPopup from "./InfoPopup";
    import ToggleUserStatus from "./ToggleUserStatus";
    export default {
        name: "Accounts",
        components: {
            InfoPopup,
            Loading,
            ToggleUserStatus
        },
        data: function () {
            return {
                accounts: [],
                isBusy: true,
                showempty: true,
                height: "",
                info: {
                    message: "",
                    title: ""
                },
                isLoading: false,
                fullPage: true,
                removemessage: "",
                isRemoveClicked: false,
                isRemoveAllClicked: false,
                user_name: this.$store.getters.username,
                removeData: {},
                accountexpandStateIcon: "plus-circle",
                accountContactRelationList: this.editingUserAssociatedAccounts,
                isAccountLoaded: false,
                selectedAccount: {},
                message: "The user cannot be removed from this Account because it is designated as the Primary Account. Continuing will deactivate the contact and disable access to the Customer Community and Support Site." +
                "Deactivated contacts can be reactivated and re-enabled later by clicking their username and clicking the toggle on Global User Status if needed.",
                headerMessage: "Information",
                StatusButtonTxt: "Deactivate Contact",
                removeAccount: {},
                detailsVisible: false
            };
        },
        props: {
            editingUserAssociatedAccounts: Array,
            sfContactID: String,
            srcAccount: Object,
            allAccounts: [],
            userDetail: {}

        },
        computed: {
            columnsfield: function () {
                var fields = [
                    {
                        key: "cadebillAccountNo",
                        label: "Account Number",
                        tdClass: ["th-td-min-width", "cell-ellipsis", "account-tdClass"],
                        thClass: ["th-td-min-width", "account-thClass"]
                    },
                    {
                        key: "accountName",
                        tdClass: ["th-td-min-width", "cell-ellipsis", "account-tdClass"],
                        thClass: ["th-td-min-width", "account-thClass"]
                    },
                    {
                        key: "Remove",
                        tdClass: ["th-td-min-width", "cell-ellipsis", "account-tdClass"],
                        thClass: ["th-td-min-width", "account-thClass"]
                    },
                    {
                        key: "sfAccountContactRelationId",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "sfAccountID",
                        tdClass: "display-none",
                        thClass: "display-none"
                    }
                ];
                return fields;
            }
        },
        updated() {
            if (!this.isAccountLoaded) {
                this.$refs.selectableAccountsTable.selectRow(0);
                this.isAccountLoaded = true;
            }
        },
        mounted() {
            //console.log("Accounts Mounted Start", this.editingUserAssociatedAccounts);
            var that = this;
            if (that.sfContactID != "") {
                that.GetAccounts();
            }
            eventbus.$on("accountsOkChanges", function () {
                that.okChanges();
            });

            that.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
                if (collapseId == "account-list") {
                    if (isJustShown) {
                        that.accountexpandStateIcon = "minus-circle";
                    } else {
                        that.accountexpandStateIcon = "plus-circle";
                    }
                }
            });
        },
        methods: {
            async GetAccounts() {
                var that = this;
                that.isBusy = true;
                if (that.sfContactID != "") {
                    that.accounts = that.accountContactRelationList.sort(function (a, b) {
                        return (a.cadebillAccountNo == b.cadebillAccountNo)
                            ? 0
                            : (a.cadebillAccountNo == that.srcAccount.accountNumber)
                                ? -1
                                : (b.cadebillAccountNo == that.srcAccount.accountNumber)
                                    ? 1
                                    : (a.cadebillAccountNo < b.cadebillAccountNo)
                                        ? -1
                                        : (a.cadebillAccountNo > b.cadebillAccountNo)
                                            ? 1
                                            : 0
                    });

                    eventbus.$emit("setAssociatedAccount", that.accounts);

                    that.isBusy = false;
                } else {
                    that.accounts = [];
                }
                return that.accounts;
            },
            setAccount: function (items) {
                if (items.length > 0) {
                    this.selectedAccount = items[0];
                    eventbus.$emit("setAccountApplicationAccess", items[0]);
                }
            },
            RemoveAllNotification: function () {
                if (!this.$store.getters.isImpersonation) {
                    this.clear();
                    this.isRemoveAllClicked = true;
                    this.removemessage =
                        "This request will remove the user association to the accounts listed in the accounts table. Note that the user may be associated to other accounts you do not have access to and will remain associated to those accounts.";
                    this.$bvModal.show("RemovePromptModal");
                }
                else {
                    this.info.title = "Information Message";
                    this.info.message = "This action is not allowed while impersonating";
                    this.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }

            },
            ConfirmYesClick: function () {
                this.$refs["RemovePromptModal"].hide();
                if (this.isRemoveAllClicked == true) {
                    if (this.allAccounts != null && this.allAccounts != "" && this.allAccounts != "undefined") {
                        if (this.allAccounts.length == 1 && this.allAccounts[0].isPrimaryAccount) {
                        if (!this.userDetail.enabled) {
                            this.info.message = "The user cannot be removed from this Account because it is designated as the Primary Account. The user is inactive and access to the Customer Community and Support Site is disabled.";
                            this.info.title = "Information Message";
                            this.$bvModal.show("infopopup");
                        } else {
                            this.$refs.UserStatusModal.isEnabled = true;
                            this.$refs.UserStatusModal.$refs["toggleUserStatusModal"].show()
                        }
                    }
                       else if (this.checkforPrimeryAccount()) {
                            this.$bvModal.show("infopopup");
                        } else {
                            this.confirmRemoveAll();
                        }
                    }
                } else if (this.isRemoveClicked == true) {
                    this.confirmRemove();
                }
            },
            confirmRemoveAll: function () {
                var that = this;
                that.isLoading = true;
                var accountContactRelationModel = {
                    AccountContactRelationList: that.accounts
                };
                var _dataurl = "api/User/RemoveAllAccountForUser/";
                service
                    .RemoveAllAccount(_dataurl, accountContactRelationModel)
                    .then(data => {
                        if (data.status == "200") {
                            that.accounts = [];
                            that.clear();
                            that.isLoading = false;
                            eventbus.$emit("setAssociatedAccount", that.accounts, that.sfContactID, null);
                        }
                    })
                    .catch(error => {
                        console.log("api error:" + error);
                    });
            },
            okChanges: function () {
                this.$bvModal.hide("infopopup");
                this.clear();
            },
            clear: function () {
                this.isRemoveAllClicked = false;
                this.isRemoveClicked = false;
                this.info.message = "";
                this.info.title = "";
                this.removemessage = "";
                this.isLoading = false;
                this.removeData = {};
            },
            onStatusChanged(value) {
                this.userDetail.enabled = value;
                this.$emit("UserStatusChanged", value);
                this.$emit("setEnableStatus", value);
                
            },
            remove: function (data) {
                var that = this;
                if (!this.$store.getters.isImpersonation) {
                    that.clear();
                    that.isRemoveClicked = true;
                    if (that.allAccounts != null && that.allAccounts != "" && that.allAccounts != "undefined") {
                        if (that.allAccounts.length == 1 && that.allAccounts[0].isPrimaryAccount) {
                            if (!that.userDetail.enabled) {
                                that.info.message = "The user cannot be removed from this Account because it is designated as the Primary Account. The user is inactive and access to the Customer Community and Support Site is disabled.";
                                this.info.title = "Information Message";
                                that.$bvModal.show("infopopup");
                            } else {
                                that.$refs.UserStatusModal.isEnabled = true
                                that.$refs.UserStatusModal.$refs["toggleUserStatusModal"].show()
                            }
                        } else {
                            that.removeData = data.item.sfAccountContactRelationId;
                            that.removeAccount = data.item.sfAccountID;
                            if (that.checkforPrimeryAccount(that.removeData)) {
                                that.$bvModal.show("infopopup");
                            } else {
                                that.$bvModal.show("RemovePromptModal");
                            }
                        }
                    }
                }
                else {
                    that.info.title = "Information Message";
                    that.info.message = "This action is not allowed while impersonating";
                    that.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            },

            confirmRemove: function () {
                var that = this;
                that.isLoading = true;
                var accountdata = that.accounts.find(
                    x => x.sfAccountContactRelationId === that.removeData
                );
                var userdetailObject = {
                    SFAccountId: accountdata.sfAccountID,
                    SFContactId: accountdata.sfContactId,
                    LoggedInUserName: this.user_name,
                    AccountNumber: accountdata.cadebillAccountNo,
                    AdfsGUID: accountdata.contactADFSGuid
                };
                service
                    .RemoveAccount(userdetailObject)
                    .then(data => {
                        if (data.status == "200") {
                            that.accounts.splice(
                                that.accounts.indexOf(
                                    that.accounts.find(
                                        x => x.sfAccountContactRelationId === that.removeData
                                    )
                                ),
                                1
                            );
                            var keep = that.allAccounts.findIndex(x => x.accountId === that.removeAccount);
                            if (keep > -1) {
                                that.allAccounts.splice(keep, 1);
                            }
                            eventbus.$emit("setAssociatedAccount", that.accounts, accountdata.sfContactId, accountdata.sfAccountID);
                            //if (that.selectedAccount.sfAccountID === accountdata.sfAccountID) {
                            setTimeout(function () {
                                that.$refs.selectableAccountsTable.selectRow(0)
                            }, 10);
                            //}
                            that.clear();
                        }
                    })
                    .catch(error => {
                        console.log("api error:" + error);
                    });
            },
            checkforPrimeryAccount: function (sfAccountContactRelationId) {
                var isPrimery = false;
                if (
                    typeof sfAccountContactRelationId == "undefined" ||
                    sfAccountContactRelationId == ""
                ) {
                    var _account = this.accounts.find(x => x.direct == true);
                    if (typeof _account !== "undefined" && _account.direct == true) {
                        this.info.message =
                            "This is the primary account, account = " +
                            _account.accountName + " for this user" +
                            ".In order to remove the user from this account, please contact your Support representative to request the Primary designation be changed to a different account.";
                        this.info.title = "Error";
                        isPrimery = _account.direct;
                    } else {
                        this.info.title = "Information";
                        this.info.message =
                            "This request will remove the user association to all accounts "; //TODO : story 75591 : This message need to discuss as mentioned in
                        isPrimery = false;
                    }
                } else if (sfAccountContactRelationId != "") {
                    var __account = this.accounts.find(
                        x => x.sfAccountContactRelationId == sfAccountContactRelationId
                    );
                    if (typeof __account !== "undefined" && __account.direct == true) {
                        this.info.message =
                            "This is the primary account, account = " +
                            __account.accountName + " for this user" +
                            ".In order to remove the user from this account, please contact your Support representative to request the Primary designation be changed to a different account.";
                        this.info.title = "Error";
                        isPrimery = __account.direct;
                    } else {
                        this.removemessage =
                            "This request will remove the user association to account " +
                            __account.accountName;
                        isPrimery = false;
                    }
                }
                return isPrimery;
            }
        }
    };
</script>